var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChild = function SvgChild(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 17",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.01 2.658a1.12 1.12 0 0 1 1.6 0l.088.1c.352.45.323 1.105-.088 1.522l-3.5 3.54 1.393 5.92H9.1v2.112a1.14 1.14 0 0 1-1.11 1.146c-.635.013-1.155-.527-1.155-1.169V13.74h-.67v2.112a1.14 1.14 0 0 1-1.11 1.146C4.42 17.01 3.9 16.47 3.9 15.829V13.74H2.497L3.89 7.82.39 4.278a1.157 1.157 0 0 1 .023-1.643 1.135 1.135 0 0 1 1.594.04l2.65 2.686a2.583 2.583 0 0 0 3.688 0zM6.5 0c1.442 0 2.61 1.184 2.61 2.646 0 1.46-1.168 2.645-2.61 2.645S3.89 4.107 3.89 2.646 5.058 0 6.5 0"
  })));
};
export default SvgChild;